import React from 'react';
import { Quote } from 'lucide-react';
import { Card } from './ui/Card';
export function Testimonials() {
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-193">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-194">
        <div className="absolute top-10 left-10 w-80 h-80 bg-red-600 rounded-full blur-3xl" data-id="element-195"></div>
        <div className="absolute bottom-10 right-10 w-80 h-80 bg-amber-500 rounded-full blur-3xl" data-id="element-196"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-197">
        <div className="text-center mb-20" data-id="element-198">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-black mb-6 leading-tight text-gray-900" data-id="element-199">
            Lo que dicen los <span className="text-amber-600" data-id="element-200">Docentes</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-201">
            Colegas que ya transformaron sus clases con el MegaPack.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 max-w-6xl mx-auto" data-id="element-202">
          <Card className="bg-white border-gray-200 p-10 relative hover:transform hover:-translate-y-2 transition-all duration-300 shadow-lg" data-id="element-203">
            <Quote className="absolute top-8 right-8 w-10 h-10 text-gray-300 opacity-40" data-id="element-204" />
            <div className="flex items-center gap-4 mb-8" data-id="element-205">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-2xl font-black text-white shadow-xl" data-id="element-206">
                L
              </div>
              <div data-id="element-207">
                <h4 className="font-black text-gray-900 text-xl" data-id="element-208">Laura G.</h4>
                <p className="text-base text-gray-600 font-medium" data-id="element-209">Primaria</p>
              </div>
            </div>
            <p className="text-gray-700 italic leading-relaxed text-lg" data-id="element-210">
              "Me ordenó todo el año. Las actividades son claras, divertidas y
              funcionan de verdad."
            </p>
          </Card>

          <Card className="bg-white border-gray-200 p-10 relative hover:transform hover:-translate-y-2 transition-all duration-300 shadow-lg" data-id="element-211">
            <Quote className="absolute top-8 right-8 w-10 h-10 text-gray-300 opacity-40" data-id="element-212" />
            <div className="flex items-center gap-4 mb-8" data-id="element-213">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-2xl font-black text-white shadow-xl" data-id="element-214">
                M
              </div>
              <div data-id="element-215">
                <h4 className="font-black text-gray-900 text-xl" data-id="element-216">Martín R.</h4>
                <p className="text-base text-gray-600 font-medium" data-id="element-217">
                  Secundaria
                </p>
              </div>
            </div>
            <p className="text-gray-700 italic leading-relaxed text-lg" data-id="element-218">
              "Los proyectos están armados paso a paso. Mis clases mejoraron y
              yo planifico muchísimo menos."
            </p>
          </Card>

          <Card className="bg-white border-gray-200 p-10 relative hover:transform hover:-translate-y-2 transition-all duration-300 shadow-lg" data-id="element-219">
            <Quote className="absolute top-8 right-8 w-10 h-10 text-gray-300 opacity-40" data-id="element-220" />
            <div className="flex items-center gap-4 mb-8" data-id="element-221">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-2xl font-black text-white shadow-xl" data-id="element-222">
                S
              </div>
              <div data-id="element-223">
                <h4 className="font-black text-gray-900 text-xl" data-id="element-224">Sofía P.</h4>
                <p className="text-base text-gray-600 font-medium" data-id="element-225">
                  Tallerista
                </p>
              </div>
            </div>
            <p className="text-gray-700 italic leading-relaxed text-lg" data-id="element-226">
              "Uso el banco de dinámicas todas las semanas. Siempre tengo un
              'plan B' listo."
            </p>
          </Card>
        </div>
      </div>
    </section>;
}